import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionUpdatesData, PetitionUpdatesList } from '#src/app/pages/petitionDetails/shared/types';

import { extractDisplayedUpdates } from './extractDisplayedUpdates';

export function useDisplayedUpdates(updatesData: PetitionUpdatesData | undefined): PetitionUpdatesList {
	const {
		data: {
			petition: {
				signatureState: {
					signatureCount: { displayed },
				},
			},
		},
	} = usePetitionDetailsPageData();

	return useMemo(() => {
		if (!updatesData) {
			return [];
		}
		return extractDisplayedUpdates(updatesData.updates, displayed);
	}, [updatesData, displayed]);
}
